import script from "./PlaylistMediaSidePanel.vue?vue&type=script&setup=true&lang=js"
export * from "./PlaylistMediaSidePanel.vue?vue&type=script&setup=true&lang=js"

import "./PlaylistMediaSidePanel.vue?vue&type=style&index=0&id=324208f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-324208f9"]])

export default __exports__